// Infrastructure
import fixtures from './fixtures.json';

// Domain
import { OriginRepository } from '../../../domain/repository';
import { OriginEntity } from '../../../domain/entities/origin-entity';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class OriginDummyRepository implements OriginRepository {
  // eslint-disable-next-line class-methods-use-this
  execute(): Promise<Array<OriginEntity>> {
    return Promise.resolve(fixtures);
  }
}
